import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MobilePageHeader } from "../components/layout/MobileAppChrome";
import CategorySection from "../components/home/CategorySection";
import { useProducts } from "../contexts/ProductContext";
import { fetchCategoriesBanner } from "../services/bannerService";
import { Banner } from "../types/store";
import { resolveMediaUrl } from "../utils/mediaUrl";
import "../styles/pages/MobileMarketplace.css";
import "../styles/pages/HomePage.css";

const categoryDisplayOrder = [
  "Electricals",
  "Hardware",
  "Plumbing",
  "Lighting & Fans",
  "Power Tools",
  "Kitchen",
  "Appliances",
  "Paints & More",
];

const CategoriesPage: React.FC = () => {
  const { categories } = useProducts();
  const [categoriesBanner, setCategoriesBanner] = useState<Banner | null>(null);
  const orderByName = new Map(
    categoryDisplayOrder.map((name, index) => [name.toLowerCase(), index])
  );
  const categoryEntries = [...categories].sort((left, right) => {
    const leftOrder = orderByName.get(left.name.toLowerCase()) ?? categoryDisplayOrder.length;
    const rightOrder = orderByName.get(right.name.toLowerCase()) ?? categoryDisplayOrder.length;
    return leftOrder - rightOrder || left.name.localeCompare(right.name);
  }).filter((category) => category.slug !== "services" && category.name.trim().toLowerCase() !== "services");

  useEffect(() => {
    let isMounted = true;

    const loadCategoriesBanner = async () => {
      try {
        const response = await fetchCategoriesBanner();
        if (isMounted) {
          setCategoriesBanner(response);
        }
      } catch {
        if (isMounted) {
          setCategoriesBanner(null);
        }
      }
    };

    void loadCategoriesBanner();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <section className="mobile-market-page categories-app-page categories-page">
      <MobilePageHeader title="Categories" />
      <CategorySection
        categories={categoryEntries}
        title="Shop by Category"
        showTitle={true}
        showAction={false}
        className="home-category-section mobile-reference-home__categories"
        gridClassName="mobile-reference-home__category-grid categories-page__category-grid"
      />
      {categoriesBanner?.imageUrl ? (
        <Link
          className="categories-page__banner"
          to={`/products?discover=1&view=collection${categoriesBanner.slug ? `&promo=${encodeURIComponent(categoriesBanner.slug)}` : ""}${categoriesBanner.heading ? `&title=${encodeURIComponent(categoriesBanner.heading)}` : ""}`}
          aria-label={categoriesBanner.heading || "Open categories banner"}
        >
          <img
            src={resolveMediaUrl(categoriesBanner.imageUrl)}
            alt={categoriesBanner.heading || "Categories banner"}
            className="categories-page__banner-image"
            style={{
              display: "block",
              width: "100%",
              height: "100%",
              objectFit: "fill",
              objectPosition: "center center",
              padding: "10px",
              borderRadius: "25px",
            }}
          />
        </Link>
      ) : null}
    </section>
  );
};

export default CategoriesPage;
